export default "__VITE_ASSET__CFLbtWXA__"